// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__sYsQ6","footer":"ModalCreateQualiphyProcedure_footer__2z5I2","additionData":"ModalCreateQualiphyProcedure_additionData__2VhXf"};